import React from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  HStack,
  Heading,
  SkeletonText,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import EmptyState from "./EmptyState";
import ErrorState from "./ErrorState";

const PlansTable = ({
  plans,
  isLoading,
  formatCurrency,
  formatDateTime,
  statusColor,
  hasAccess,
  onRetry,
  onDelete,
}) => {
  const showActions = typeof onDelete === "function";
  return (
    <Card variant="outline" _hover={{ boxShadow: "md" }} transition="box-shadow 0.2s ease">
      <CardHeader>
        <HStack justify="space-between">
          <Heading size="sm">Plans</Heading>
          <Text fontSize="sm" color="gray.500">
            {plans.length} records
          </Text>
        </HStack>
      </CardHeader>
      <CardBody>
        {isLoading ? (
          <SkeletonText noOfLines={6} spacing="3" />
        ) : !hasAccess ? (
          <ErrorState
            title="Plan list unavailable"
            description="The plans endpoint is not available. You can still create subscriptions with a manual plan ID."
            onRetry={onRetry}
          />
        ) : plans.length === 0 ? (
          <EmptyState title="No plans yet" description="Create a subscription plan to start recurring billing." />
        ) : (
          <TableContainer>
            <Table size="sm">
              <Thead>
                <Tr>
                  <Th>Name</Th>
                  <Th isNumeric>Amount</Th>
                  <Th>Interval</Th>
                  <Th>Status</Th>
                  <Th>Created</Th>
                  {showActions ? <Th></Th> : null}
                </Tr>
              </Thead>
              <Tbody>
                {plans.map((plan) => (
                  <Tr key={plan.id}>
                    <Td>{plan.name}</Td>
                    <Td isNumeric>{formatCurrency(plan.amount, plan.currency)}</Td>
                    <Td>{plan.intervalUnit} x {plan.intervalCount}</Td>
                    <Td>
                      <Badge colorScheme={statusColor(plan.active ? "ACTIVE" : "INACTIVE")}>
                        {plan.active ? "ACTIVE" : "INACTIVE"}
                      </Badge>
                    </Td>
                    <Td>{formatDateTime(plan.createdAt)}</Td>
                    {showActions ? (
                      <Td>
                        <Button
                          size="xs"
                          variant="outline"
                          colorScheme="red"
                          onClick={() => onDelete(plan)}
                        >
                          Deactivate
                        </Button>
                      </Td>
                    ) : null}
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        )}
      </CardBody>
    </Card>
  );
};

export default PlansTable;
